/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/anchor-has-content */
import React, { useRef, useState } from "react";
import { Popover } from "@material-ui/core";
import { toAbsoluteUrl } from "../../_metronic/utils/utils";

import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import CloseIcon from '@material-ui/icons/Close';
import { getJobServices,createPaymentLink,PAYMENT_SOCKET_URL, getProductRDetails} from "../crud/auth.crud";
import { parse } from "date-fns";
import WebSocket from 'isomorphic-ws';
import Alert from '@material-ui/lab/Alert'

import CircularProgress from '@material-ui/core/CircularProgress';


export default function ProductRequirement({onClose,productRequirement,patient}) {
  
 const [requirements,setRequirements] = useState([]);
 const [loading,setLoading] = useState(false);
 const [total,setTotal] = useState(0);
 const [link,setLink] = useState(null);
 const [paymentLoading,setPaymentLoading] = useState(false);
 

 const [seconds, setSeconds] = useState(300); // 5 minutes * 60 seconds
  const [isActive, setIsActive] = useState(false);

 React.useEffect(() => {
         const fetch = async () => {
             try {
              setLoading(true);

             
                 let services = [];
                 const response = await getProductRDetails(productRequirement.id);
                 services = response.data;
              
               console.log("final:::",services);
               //setIntervalz(parseInt(intervalz));
               setRequirements(services);
              
               setLoading(false);
 
             } catch (e) {
                 console.log(e);
                 setLoading(false);
                 
             }
         };
         fetch();
     }, []);

   

  return (
    <>
      <div className="kt-portlet kt-portlet--height-fluid">
        <div className="kt-portlet__head">
          <div className="kt-portlet__head-label">
            <h3 className="kt-portlet__head-title">Staged Inventory for {patient.firstName + ' '+patient.lastName }</h3>
          </div>
          <div className="kt-portlet__head-toolbar">
           
            <a href="#" onClick={onClose}><CloseIcon style={{ color: '#5867dd',fontSize: 25}} /> </a>
          </div>
        </div>

        <div className="kt-portlet__body">
          {loading ===false &&
          <div className="kt-widget4">
         
         
          {requirements.map((st)=>(
            <div className="kt-widget4__item" key={st.id}>
              
              <div className="kt-widget4__info">
                <a
                  className="kt-widget4__username"
                  href="#"
                />
                <a
                  className="kt-widget4__title"
                  href="#"
                >
                   {st.product.productName}
                </a>
                <p className="kt-widget4__text">{'Qty: '+st.quantity}</p>
              </div>
              
            </div>
           ))}
           
          </div>
          }
          {loading===true && 
              <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>
                  <CircularProgress />
              </div>
          }
        </div>
       
        
        
        
      </div>
    </>
  );
}
